import { Controller } from "@hotwired/stimulus"
var Highcharts = require('highcharts');  
// Load module after Highcharts is loaded
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);  

// Connects to data-controller="wordcloud"
export default class extends Controller {
  static targets = [ "link", "maxWordsButtons", "wordCategoriesButtons" ]
  series_colors = {
    "all": "#ADADAD",
    "noun": "#D5D1FF",
    "adjective": "#BEF5E5",
    "verb": "#F9CB75",
    "adverb": "#FFB1BB",
    "other": "#CAEDFF"
  }

  connect() {
    this.colorizeWordCategoriesButtons()
    this.series = this.getSeries()
    this.active_serie = "All"
    this.serie_max_length = 25
    this.setButtonsState(this.serie_max_length, this.active_serie)

    if (this.series != null) { 
      const series_top = this.topWords(this.series, this.serie_max_length)
      const default_serie = this.selectSeriesWithName(this.active_serie, series_top)
      
      this.loadChart(default_serie, {color: this.series_colors[this.active_serie.toLowerCase()]})
    }
  }

  colorizeWordCategoriesButtons() {
    const currentLemma = new URL(this.linkTarget.href).searchParams.get("lemma")
    this.wordCategoriesButtonsTargets.forEach((button) => {
      const color_square = button.querySelector("div")
      if (color_square) {
        color_square.style.backgroundColor = this.series_colors[button.value.toLowerCase()]
        if (currentLemma) {
          button.classList.remove("d-flex")
          button.classList.add("d-none")
        }
      }
    })
  }

  setButtonsState(maxWords=false, wordCategories=false) {
    this.maxWordsButtonsTargets.forEach((button) => {
      button.classList.remove("active")
      if (maxWords && button.value == maxWords) {
        button.classList.add("active")
      }
    })
    this.wordCategoriesButtonsTargets.forEach((button) => {
      button.classList.remove("active")
      if (wordCategories && button.value.toLowerCase() == wordCategories.toLowerCase()) {
        button.classList.add("active")
      }
    })
  }

  loadChart(series, options={}) {
    Highcharts.chart("wordcloud", {
      chart: {
          type: 'packedbubble'
      },
      title: {
        text: ''
      },
      tooltip: {enabled: false},
      legend: {
        enabled: false
      },
      plotOptions: {
        packedbubble: {
          color: options.color,
          useSimulation: true,
          layoutAlgorithm: {
            // splitSeries: true,
            dragBetweenSeries: false,
          },
          minSize: '50%',
          maxSize: '100%',
          dataLabels: {
            enabled: true,
            useHTML: true,
            format: '<div style="text-align:center">{point.name}<br><span style="opacity: 0.5; font-weight: bold">{point.value}</span></div>',
            filter: {
                property: 'y',
                operator: '>',
                value: 0
            },
            style: {
                color: 'black',
                textOutline: 'none',
                fontWeight: 'normal'
            }
          },
          cursor: 'pointer',
          events: {
              click: this.onBubbleClick
          }
        }

      },
      series: series
    });
  }

  selectSeriesWithName(name, series) {
    return series.filter(serie => serie.name.toLowerCase() === name.toLowerCase())
  }

  topWords(series, number_of_words) {
    series = series.map((serie) => {
      return {name: serie.name, data: serie.data.slice(0, number_of_words)}
    });
    return series
  }

  getSeries() {
    const currentLemma = new URL(this.linkTarget.href).searchParams.get("lemma")
    const tags = JSON.parse(this.element.dataset.tags).filter(tag => tag !== null && tag !== undefined)
    if (_.isEmpty(tags)) {
      return null
    }
    const tags_types = new Set(tags.map(tag => tag.tag))
    if (tags_types.has(undefined)) {
      tags_types.delete(undefined)
    }
    if (tags_types.size === 0) {
      return null
    }
    const series = [...tags_types].map((type) => { return { name: type, data: [] } })

    tags.forEach(tag => {
      if (tag.lemma === undefined || tag.tag === undefined) {
        return;
      }
      const serie_index = series.findIndex(serie => serie.name === tag.tag)
      const index = series[serie_index].data.findIndex((data) => {
        return data.name === tag.lemma
      })
      if (index != -1) {
        series[serie_index].data[index].value += 1
      } else {
        if (currentLemma && tag.lemma.toLowerCase() === currentLemma.toLowerCase()) {
          series[serie_index].data.push({value: 1, name: tag.lemma, color: "#000000", selected: true })
        } else {
          series[serie_index].data.push({value: 1, name: tag.lemma })
        }
      }
    });

    series.map((serie) => {
      serie.data.sort((a,b) => {return b.value - a.value})
    })

    series.forEach((serie) => {
      serie.data.forEach((data) => {
        data.color = this.series_colors[serie.name.toLowerCase()]
      })
    })
    const all = series.map(serie => serie.data).flat().sort((a,b) => {return b.value - a.value})
    series.push({name: "all", data: all})

    return series
  }

  selectTop(event) {
    this.serie_max_length = event.target.value
    const series_top = this.topWords(this.series, this.serie_max_length )
    const serie = this.selectSeriesWithName(this.active_serie, series_top)
    this.setButtonsState(this.serie_max_length, this.active_serie)

    this.loadChart(serie, {color: this.series_colors[this.active_serie.toLowerCase()]} )
  }

  onSerieNameChange(event) {
    this.active_serie = event.target.value
    const series_top = this.topWords(this.series, this.serie_max_length )
    const serie = this.selectSeriesWithName(this.active_serie, series_top)
    this.setButtonsState(this.serie_max_length, this.active_serie)

    this.loadChart(serie, {color: this.series_colors[this.active_serie.toLowerCase()]})
  }

  onBubbleClick(event) {
    const lemma = event.point.name
    const filterLink = document.querySelector('[data-wordcloud-target="link"]')
    const url = new URL(filterLink.href)
    const currentLemma = url.searchParams.get("lemma")

    if (currentLemma == lemma) {
      url.searchParams.delete("lemma")
    } else {
      url.searchParams.set("lemma", lemma)
    }
    filterLink.href = url.href
    filterLink.click()
  }
}
